import { DataTableV2, Intro, Image, Text } from "components/commons";
import { locale } from "localization/en";
import PurchaseOrderFilter from "./purchase-order-filter";
import { useRouter, useModal, useApi } from "hooks";
import { useContext } from "react";
import { StationContext } from "contexts";
import { purchaseOrderColumn } from "./purchase-order-list-column";
import { mapDataToList, mapFilterToRequest } from "./purchase-order-list-mapper";
import { getPurchaseOrderListApi } from "apis";
import { initialFilterState } from "./purchase-order-filter.state";
import useDataTable from "hooks/useDataTable";
import { WomanCancel } from "images";
import { ConfirmModal } from "components/modals";
import { updatePurchaseOrderByIdApi } from "apis";
import { OrderStatus } from "enums";
import styles from "./purchase-order-details/purchase-order-form/purchase-order.module.scss";

const PurchaseOrderModule = () => {
  const { station } = useContext(StationContext);
  const { history } = useRouter();
  const cancelModal = useModal();
  const successModal = useModal();

  const { request: updatePurchaseOrder, loading: isUpdating } = useApi({
    api: updatePurchaseOrderByIdApi,
    modalError: true,
  });

  const showCancelModal = (orderId) => {
    cancelModal.show({
      primary: {
        text: locale.cancelAnyway,
        onClick: async () => {
          const result = await updatePurchaseOrder({
            id: orderId,
            status: OrderStatus.Canceled,
          });

          if (result?.error) {
            return;
          }

          cancelModal.close();

          successModal.show({
            primary: {
              text: locale.gotIt,
              onClick: () => {
                refetchData();
                successModal.close();
              },
            },
          });
        },
        loading: isUpdating,
      },
      secondary: {
        text: locale.goBack,
        loading: isUpdating,
        onClick: async () => {
          cancelModal.close();
        },
      },
    });
  };

  const { filter, search, table } = useDataTable({
    api: {
      api: getPurchaseOrderListApi,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateBy: true,
      },
    },
    table: {
      key: "orders",
      mapper: (orders) =>
        mapDataToList({
          orders,
          history,
          showCancelModal,
        }),
      columns: purchaseOrderColumn,
    },
  });

  const refetchData = () => {
    table.refetch();
  };

  return (
    <div>
      <Intro title={locale.purchaseOrder} />
      <PurchaseOrderFilter {...filter} {...search} />
      <DataTableV2 {...table} />
      <ConfirmModal {...cancelModal} closable={false} centerActions>
        <div className={styles.successModal}>
          <Image src={WomanCancel} />
          <br />
          <Text strong className={styles.title}>
            {locale.cancelPurchaseOrder}
          </Text>
          <Text className={styles.message}>
            {locale.areYouSureYouWantToCancelThisPurchaseOrder}
          </Text>
        </div>
      </ConfirmModal>
      <ConfirmModal {...successModal} closable={false} centerActions>
        <div className={styles.successModal}>
          <Image src={WomanCancel} />
          <br />
          <Text strong className={styles.title}>
            {locale.purchaseOrderCancelled}
          </Text>
          <Text className={styles.message}>{locale.thePurchaseOrderHasBeenCancelled}</Text>
        </div>
      </ConfirmModal>
    </div>
  );
};

export default PurchaseOrderModule;
